<div *ngIf="isCreator(course)" class="course-creator-tools">
  <button (click)="onPublishClick(course)">{{getPublishedText(course)}}</button>
  <button class="delete-button" (click)="onDeleteClick(course)"><i class="material-icons">delete</i></button>
</div>